export const MFA_PREFERENCE_MESSAGE = {
  SMS: 'Ingresa el código que te enviamos por SMS para realizar tu retiro.',
  TOTP: 'Ingresa el código que generó tu app de autenticación para realizar tu retiro.',
};

export const MFA_PREFERENCE_ADD_ACCOUNT_MESSAGE = {
  SMS: 'Ingresa el código que te enviamos por SMS para confirmar el registro',
  TOTP: 'Ingresa el código que generó tu aplicación para confirmar el registro',
};

export const MFA_TYPE = {
  SMS: 0,
  TOKEN: 1,
  DISABLED: 2,
};

export const TOKEN_INFO_TYPE = {
  DISABLED: 'Disabled',
  SMS: 'SMS',
  TOTP: 'TOTP',
};
